import { useQuery } from '@apollo/client';
import { FormItem, Select } from 'Components';
import { FormItemProps } from 'Components/Form/FormItem/FormItem';
import { SelectProps } from 'Components/Form/Select/Select';
import { getUserRoleLabel } from 'app-util';
import { useTranslation } from 'react-i18next';
import { GET_USER_ROLES } from 'Services/Api/Masterdata/Queries';
import { GetUserRolesResponse } from 'Services/Api/Masterdata/Types';
import { unActiveSelectSearch } from '../Profile/Profile.helpers';

type UserRoleFieldProps = Pick<FormItemProps, 'className' | 'label'> &
	Pick<SelectProps, 'onChange' | 'disabled' | 'value'> & {
 	isProfile?: boolean;
		error?: string;
		blockHelp?: boolean;
		required?: boolean;
		loading?: boolean;
		options?: any[];
	};
function UserRoleField({
	isProfile,
	error,
	label,
	className,
	blockHelp,
	required,
	loading,
	options,
	...selectProps
}: UserRoleFieldProps) {
	const { t } = useTranslation();
	return (
		<FormItem
			className={className}
			label={label === false ? null : label ?? t('user.lmsRole.label')}
			validateStatus={(error && 'error') || undefined}
			help={blockHelp ? undefined : error}
			required={required}
		>
			<Select.ScrollHandled
				{...selectProps}
				loading={loading}
				disabled={isProfile || loading || selectProps.disabled}
				optionFilterProp="children"
				showSearch={false}
				className='user-role-class'
				placeholder={t('profile.general.placeholders.userRoleClass') || 'Select user role'}
				onSelect={() => unActiveSelectSearch('.user-role-class')}
			>
				{options?.map((userRole) => {
					if (userRole.role !== 'superadmin') {
						return (
							<Select.Option key={userRole.id} value={userRole.id}>
								{getUserRoleLabel(userRole.role)}
							</Select.Option>
						);
					}
				})}
			</Select.ScrollHandled>
		</FormItem>
	);
}

export default UserRoleField;
